function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-stack-spacing/dist/index.module.css';
function Stack(_ref) {
  let {
    flex,
    spacing,
    children,
    vertical,
    inline,
    justify,
    align,
    wrap,
    height,
    overflow,
    position,
    testHandle
  } = _ref;
  const el = useRef();
  useEffect(() => {
    // set the stack-spacing variable for this instance
    let updatedStacking = spacing;
    if (spacing < 0 || spacing >= 8) {
      updatedStacking = 0;
    }
    if (el.current) {
      el.current.style.setProperty(vertical ? '--sib-stack-row-spacing' : '--sib-stack-column-spacing', `var(--sib-spacing_${updatedStacking})`);
    }
  }, [spacing]);
  const stylesObj = {
    flex,
    height,
    overflow,
    position,
    display: inline ? 'inline-flex' : 'flex',
    justifyContent: justify,
    alignItems: align,
    flexWrap: wrap
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: el,
    style: stylesObj,
    "data-test": testHandle,
    className: vertical ? styles['sib-rows-stack'] : styles['sib-columns-stack']
  }, children);
}
Stack.propTypes = {
  inline: PropTypes.bool,
  flex: PropTypes.string,
  justify: PropTypes.string,
  align: PropTypes.string,
  wrap: PropTypes.string,
  position: PropTypes.string,
  overflow: PropTypes.string,
  height: PropTypes.string,
  spacing: PropTypes.number,
  vertical: PropTypes.bool,
  testHandle: PropTypes.string,
  children: PropTypes.node.isRequired
};
Stack.defaultProps = {
  flex: '',
  spacing: 0,
  vertical: false,
  inline: false,
  justify: 'flex-start',
  align: 'stretch',
  wrap: 'nowrap',
  height: 'auto',
  position: 'static',
  overflow: 'visible',
  testHandle: ''
};
function VStack(_ref2) {
  let {
    children,
    ...restProps
  } = _ref2;
  return /*#__PURE__*/React.createElement(Stack, _extends({
    vertical: true
  }, restProps), children);
}
VStack.propTypes = {
  spacing: PropTypes.number,
  children: PropTypes.node.isRequired
};
VStack.defaultProps = {
  spacing: 0
};
function HStack(_ref3) {
  let {
    children,
    ...restProps
  } = _ref3;
  return /*#__PURE__*/React.createElement(Stack, _extends({
    vertical: false
  }, restProps), children);
}
HStack.propTypes = {
  spacing: PropTypes.number,
  children: PropTypes.node.isRequired
};
HStack.defaultProps = {
  spacing: 0
};
export { Stack, HStack, VStack };